import LoginEmail from './LoginEmail';
import LoginPassword from './LoginPassword';
import LoginForgot from './LoginForgot';
import LoginWorkstationContextSelect from './LoginWorkstationContextSelect';
import LoginWorkstationNoPartner from './LoginWorkstationNoPartner';
import LoginWorkstationRegister from './LoginWorkstationRegister';
import LoginWorkstationPending from './LoginWorkstationPending';
import {
  LoginMfaChallenge,
  LoginMfaInvite,
  LoginMfaInstallApp,
  LoginMfaEnroll,
  LoginMfaVerify,
} from './Mfa';

export const steps = {
  email: { component: LoginEmail, key: 'email' },
  password: { component: LoginPassword, key: 'password' },
  forgot: { component: LoginForgot, key: 'forgot' },
  workstationPartnerSelect: {
    component: LoginWorkstationContextSelect,
    key: 'workstationPartnerSelect',
  },
  workstationCondominiumSelect: {
    component: LoginWorkstationContextSelect,
    key: 'workstationCondominiumSelect',
  },
  workstationNoPartner: {
    component: LoginWorkstationNoPartner,
    key: 'workstationNoPartner',
  },
  workstationRegister: {
    component: LoginWorkstationRegister,
    key: 'workstationRegister',
  },
  workstationPending: {
    component: LoginWorkstationPending,
    key: 'workstationPending',
  },
  mfaChallenge: { component: LoginMfaChallenge, key: 'mfaChallenge' },
  mfaEnrollInvite: { component: LoginMfaInvite, key: 'mfaEnrollInvite' },
  mfaInstall: { component: LoginMfaInstallApp, key: 'mfaInstall' },
  mfaEnroll: { component: LoginMfaEnroll, key: 'mfaEnroll' },
  mfaVerify: { component: LoginMfaVerify, key: 'mfaVerify' },
};

// Steps de MFA (guard do redirect).
export const MFA_STEP_KEYS = [
  'mfaChallenge',
  'mfaEnrollInvite',
  'mfaInstall',
  'mfaEnroll',
  'mfaVerify',
];
